import React, { useState, useEffect } from 'react'
import Intro from './scenes/Intro'
import StartScreen from './scenes/StartScreen'
import MenuDida from './scenes/MenuDida'
import MenuMusic from './scenes/MenuMusic'
import Module1 from './scenes/Module1';
import Module2 from './scenes/Module2';
import Module3a from './scenes/Module3a';
import Module3b from './scenes/Module3b';
import Module3c from './scenes/Module3c';
import Module3d from './scenes/Module3d';
import Module3e from './scenes/Module3e';
import Module3f from './scenes/Module3f';
import Module4a1 from './scenes/Module4a1';
import Module4b2 from './scenes/Module4b2';
import Module4c3 from './scenes/Module4c3';
import Module5a1 from './scenes/Module5a1';
import Module5b2 from './scenes/Module5b2';
import Module5c3 from './scenes/Module5c3';
import Module5d4 from './scenes/Module5d4';
import Module5e5 from './scenes/Module5e5';
import Module5f6 from './scenes/Module5f6';
import Module6a from './scenes/Module6a';
import Module6b from './scenes/Module6b';
import Module6c from './scenes/Module6c';
import Toots from './scenes/Toots';
import Nav from './utils/Nav';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Module2v from './scenes/Module2v'
import Module6av from './scenes/Module6av'

export default function Player() {

  const [isIntroFinished, setIsIntroFinished] = useState(false);
  const [firstTime, setFirstTime] = useState(true);

  let audio = []

  const [langue, setLangue] = useState('en');

  return (
    <>
      <div
        className='background'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '660px',
          height: '500px',
          overflow: 'hidden',
        }}
      >
        <BrowserRouter>
          <div>
            <Routes>
              <Route exact path='' element={
                isIntroFinished ?
                  <Navigate to={process.env.PUBLIC_URL + "/start/"} replace /> :
                  <Intro
                    callback={() => {
                      setIsIntroFinished(true);
                    }}
                  />
              } />
              <Route path={process.env.PUBLIC_URL + '/start/'} element={<StartScreen langue={langue} setLangue={setLangue} firstTime={firstTime} setFirstTime={setFirstTime} />} />
              <Route path={process.env.PUBLIC_URL + '/menudida/'} element={<MenuDida langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/menumusic/'} element={<MenuMusic langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/1-intro/'} element={<Module1 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/2-captation/'} element={<Module2 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/2-captation-video/'} element={<Module2v langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/3-imitation-1/'} element={<Module3a langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/3-imitation-2-markov/'} element={<Module3b langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/3-imitation-3-donnalee/'} element={<Module3c langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/3-imitation-4-uzeste/'} element={<Module3d langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/3-imitation-5-walking/'} element={<Module3e langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/3-imitation-5-motifs/'} element={<Module3f langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/4-transformationA-1/'} element={<Module4a1 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/4-transformationA-2-patch/'} element={<Module4b2 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/4-transformationA-3-arpeges/'} element={<Module4c3 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/5-transformationB-1/'} element={<Module5a1 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/5-transformationB-2-hothouse/'} element={<Module5b2 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/5-transformationB-3-godel/'} element={<Module5c3 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/5-transformationB-4-reecritures/'} element={<Module5d4 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/5-transformationB-5-subtitutions/'} element={<Module5e5 langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/module/5-transformationB-5-goodbye/'} element={<Module5f6 langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/6-controle-1/'} element={<Module6a langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/6-controle-1-video/'} element={<Module6av langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/6-controle-2-lubatyscaphe/'} element={<Module6b langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/module/6-controle-3-memoire/'} element={<Module6c langue={langue} />} />
              <Route path={process.env.PUBLIC_URL + '/toots/'} element={<Toots langue={langue} audio={audio} />} />
              <Route path={process.env.PUBLIC_URL + '/toots/:page/'} element={<Toots langue={langue} audio={audio} />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Nav audio={audio} langue={langue} />
          </div>
        </BrowserRouter>
      </div>
    </>
  )
}
